module.exports = __webpack_public_path__ + "static/media/34.4e4f3526.jpg";